// extracted by mini-css-extract-plugin
module.exports = {"container":"ArrowedLink-module--container--22S7u"};